export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-posteid.svg?7c2ce090047065876f0af60acb3cdc18";